import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core";
import { withUserProfile } from "../../../../../../../../userProfile/userProfileContext";
import { formatDateTime, formatTime } from "../../utils";
import styles from "../styles";
import { compose } from "recompose";
import Detail from "./Detail";
import { withAppConfig } from "../../../../../../../../appConfigContext";

const PickupDetails = ({ classes, pickupinfo, userData, configJSON }) => {
   return (
    <div>
      <div className={classes.sectionTitle}>Pickup Details</div>
      <div className={classes.infoContainer}>
        <Grid container>
          <Detail title="Assigned By :" value={pickupinfo.assignedBy} xs={3} />
          <Detail title="Route :" value={configJSON?.showStaticRoute ? pickupinfo.staticRoute : pickupinfo.routeName} xs={2} />
          <Detail
            title="Driver :"
            value={`${pickupinfo.driverName ?? ""} ${
              pickupinfo.driverNumber ? `(#${pickupinfo.driverNumber})` : ""
            }`}
            xs={3}
          />
          <Detail title="Created By :" value={pickupinfo.createdBy} xs={4} />
        </Grid>
        <Grid container>
          <Detail
            title="Assigned Time:"
            value={formatTime(pickupinfo.pickupAssignedDateTime)}
            xs={3}
          />
          <Detail
            title="Terminal :"
            value={userData.userProfile.terminal.code}
            xs={2}
          />
          <Detail
            title="Contact :"
            value={pickupinfo.shipperContactName}
            xs={3}
          />
          <Detail
            title={`Created Date & Time :`}
            value={formatDateTime(pickupinfo.createdDateTime)}
            xs={4}
          />
        </Grid>
      </div>
    </div>
  );
};

export default compose(withUserProfile, withStyles(styles), withAppConfig)(PickupDetails);
